import DoneIcon from '@mui/icons-material/Done'
import { Box, Divider, Grid } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { roundBalance } from '../../../../util/numericalConvertors'
import { formatCurrencyUSD } from '../../../../util/formatCurrencyUSD'

const BiddingSection = ({
  balance,
  daily_budget,
  cpm_bid,
  isTotalBudgetChanged,
  isDailyBudgetChanged,
  isCpmBidChanged
}: any) => {
  const theme: any = useTheme()

  const getTitle = (name: string) => {
    return (
      <Grid item sx={{ fontSize: '16px', display: 'flex', fontWeight: 'bold' }} md={4}>
        <DoneIcon color="success" sx={{ mr: 2 }} />
        <Box sx={isTotalBudgetChanged || isDailyBudgetChanged || isCpmBidChanged ? biddingCss.chip : biddingCss.noChip}>
          {name}
        </Box>
      </Grid>
    )
  }

  const labelCss = {
    marginBottom: 1,
    color: theme.palette?.grey[500]
  }

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{ mt: 2, mb: 3, flexWrap: { xs: 'wrap', md: 'initial' } }}
      >
        {getTitle('Bidding')}
        <Grid
          item
          md={8}
          sx={{ mt: { xs: '20px', md: '0' }, maxWidth: '100%  !important', flexBasis: '100%  !important' }}
        >
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            sx={{ display: { xs: 'block', md: 'flex' } }}
          >
            <Grid item xs={6} md={4}>
              <Box
                sx={
                  isTotalBudgetChanged
                    ? { ...labelCss, color: '#C10202' }
                    : { ...labelCss, color: theme.palette?.grey[500] }
                }
              >
                Remaining Budget
              </Box>
              <Box sx={biddingCss?.labelCss}>{formatCurrencyUSD(balance)}</Box>
            </Grid>
            <Grid item xs={6} md={4}>
              <Box
                sx={
                  isDailyBudgetChanged
                    ? { ...labelCss, color: '#C10202' }
                    : { ...labelCss, color: theme.palette?.grey[500] }
                }
              >
                Daily Budget
              </Box>
              <Box sx={biddingCss?.labelCss}>{formatCurrencyUSD(daily_budget)}</Box>
            </Grid>
            <Grid item xs={6} md={4}>
              <Box
                sx={
                  isCpmBidChanged ? { ...labelCss, color: '#C10202' } : { ...labelCss, color: theme.palette?.grey[500] }
                }
              >
                CPM Bid
              </Box>
              <Box sx={biddingCss?.labelCss}>{formatCurrencyUSD(cpm_bid)}</Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Divider sx={{ mb: 1, mt: 1 }} />
    </>
  )
}

export default BiddingSection

const biddingCss = {
  labelCss: {
    fontSize: '16px',
    color: '#19181A',
    fontWeight: '600'
  },
  chip: {
    // display: 'inline-block',
    borderRadius: '999px',
    padding: '0.5em',

    backgroundColor: '#EDA6A6'
  },
  noChip: {}
}
